import { BaseQueryApi } from "@reduxjs/toolkit/dist/query";
import i18n from "../../i18n";

export const getDefaultHeaders = (
  headers: Headers,
  endpoints:
    | undefined
    | Pick<BaseQueryApi, "type" | "getState" | "extra" | "endpoint" | "forced">,
  accessToken?: string | undefined
) => {
  headers.set("Accept", "application/json;charset=UTF-8");

  if (
    !headers.has("Content-Type") &&
    endpoints?.endpoint !== "uploadFile" &&
    endpoints?.endpoint !== "postFile" &&
    endpoints?.endpoint !== "insertAudioAnswersQuestions" &&
    endpoints?.endpoint !== "fetchDocs" &&
    endpoints?.endpoint !== "sendFile"
  ) {
    headers.set("Content-Type", "application/json");
  }

  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }


  const currentLanguage = i18n?.language || localStorage.getItem("i18nextLng") || "he";
  headers.set("Accept-Language", currentLanguage);
  headers.set("X-App-Name", "client");

  return headers;
};
